import { render, staticRenderFns } from "./copy.component.vue?vue&type=template&id=44e8b4e4&scoped=true"
import script from "./copy.component.vue?vue&type=script&lang=js"
export * from "./copy.component.vue?vue&type=script&lang=js"
import style0 from "./copy.component.vue?vue&type=style&index=0&id=44e8b4e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e8b4e4",
  null
  
)

export default component.exports